import { useToast } from '@chakra-ui/react'
import { FileGenerator } from 'components/molecules/FileGenerator'
import { useState } from 'react'
import ContractService from 'services/contracts'
import { generateFile } from 'utils/blob'

export const GenerateHistoricPDF: React.FC<{
    contractId: string
}> = ({ contractId }) => {
    const [loadingHistoricFile, setLoadingHistoricFile] =
        useState<boolean>(false)
    const toast = useToast()
    const callAPI = () => {
        downloadFiles()
    }

    const downloadFiles = async () => {
        try {
            setLoadingHistoricFile(true)

            const response = await ContractService.generateContractHistoricFile(
                contractId
            )

            generateFile('PDF', response)

            toast({
                title: 'Arquivo gerado com sucesso!',
                description: `O arquivo PDF foi gerado corretamente. Verifique sua pasta de downloads para acessá-lo.`,
                position: 'bottom-left',
                status: 'success',
                isClosable: true
            })
        } catch (error) {
            toast({
                title: 'Sentimos muito!',
                description: 'Ocorreu algum erro, tente novamente mais tarde.',
                position: 'bottom-left',
                status: 'error',
                isClosable: true
            })
        } finally {
            setLoadingHistoricFile(false)
        }
    }

    return (
        <FileGenerator
            callAPI={callAPI}
            onlyPDF={true}
            loading={loadingHistoricFile}
        />
    )
}
